import { diContainer, serviceNames } from '../diContainer/diContainer';
import NotificationsCollection from '../domain/entities/Notification/NotificationsCollection';
import SalonRepository from '../repositories/SalonRepository';
import SubmitNewsletterUseCase from './SubmitNewsletterUseCase';
import RemoveBopisInfoUseCase from './RemoveBopisInfoUseCase';
import ValidateAndSubmitAddressesUseCase, { IAddressSubmissionConfig } from './ValidateAndSubmitAddressesUseCase';
import { DeliveryOptions } from '../constants/Constants';
import { NOTIFICATION_TYPE } from '../constants/Notifications';

class SubmitDeliveryScreenUseCase {
  private salonRepository: SalonRepository;

  private notificationsCollection: NotificationsCollection;

  private addressSubmissionConfig: IAddressSubmissionConfig;

  constructor(addressSubmissionConfig: IAddressSubmissionConfig) {
    this.addressSubmissionConfig = addressSubmissionConfig;
    this.notificationsCollection = diContainer.get(serviceNames.notificationsCollection);
    this.salonRepository = diContainer.get(serviceNames.salonRepository);
  }

  private submitNewsletterData = (): void => {
    const submitNewsletterUseCase = new SubmitNewsletterUseCase();
    submitNewsletterUseCase.execute();
  };

  public async execute(): Promise<void> {
    this.notificationsCollection.clearNotifications(undefined, NOTIFICATION_TYPE.DANGER);

    const removeBopisInfoUseCase = new RemoveBopisInfoUseCase();
    await removeBopisInfoUseCase.execute();

    await this.submitNewsletterData();
    if (this.addressSubmissionConfig.deliveryOption === DeliveryOptions.HOME_DELIVERY) {
      await this.salonRepository.saveUserSalon();
    }

    await new ValidateAndSubmitAddressesUseCase(this.addressSubmissionConfig).execute();

  }
}

export default SubmitDeliveryScreenUseCase;
